import { http } from '../../../../api/http';

const ENDPOINT = '/planilla/reporte';

export interface BoletaPagoData {
  empresa: string;
  rucEmpresa: string;
  periodo: string;
  fechaInicio: string;
  fechaFin: string;
  idTrabajador: number;
  nombreTrabajador: string;
  documento: string;
  area: string;
  cargo: string;
  fechaIngreso: string;
  regimenPensionario: string;
  cussp: string;
  diasLaborados: number;
  diasNoLaborados: number;
  diasSubsidiados: number;
  horasNormales: number;
  horasExtras25: number;
  horasExtras35: number;
  horasExtras100: number;
  remuneraciones: BoletaConcepto[];
  descuentos: BoletaConcepto[];
  aportes: BoletaConcepto[];
  totalRemuneraciones: number;
  totalDescuentos: number;
  totalAportes: number;
  netoPagar: number;
}

export interface BoletaConcepto {
  codigo: string;
  descripcion: string;
  monto: number;
  detalle: string | null;
}

export interface ResumenPlanillaData {
  cantidadTrabajadores: number;
  totalRemuneraciones: number;
  totalDescuentos: number;
  totalAportes: number;
  totalNeto: number;
  conceptosRemunerativos: ResumenConcepto[];
  conceptosDescuento: ResumenConcepto[];
  conceptosAporte: ResumenConcepto[];
}

export interface ResumenConcepto {
  idConcepto: number;
  codigo: string;
  descripcion: string;
  cantidadTrabajadores: number;
  montoTotal: number;
}

export class ReporteService {
  public static async getBoletaPago(idPlanilla: number, idTrabajador: number): Promise<BoletaPagoData> {
    const response = await http.get(`${ENDPOINT}/boleta/${idPlanilla}/${idTrabajador}`);
    return response.data;
  }

  public static async getResumen(idPlanilla: number): Promise<ResumenPlanillaData> {
    const response = await http.get(`${ENDPOINT}/resumen/${idPlanilla}`);
    return response.data;
  }
}
